import React from 'react';
import Icon from '../../../components/AppIcon';

const ValidationResults = ({ results }) => {
  const { errors, warnings, info } = results;

  const totalIssues = errors?.length + warnings?.length;

  if (totalIssues === 0 && info?.length === 0) return null;

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="flex items-center justify-center w-10 h-10 rounded-md bg-primary/10">
          <Icon name="AlertCircle" size={20} color="var(--color-primary)" />
        </div>
        <div>
          <h4 className="font-medium text-foreground">Resultados da Validação</h4>
          <p className="caption text-muted-foreground">
            {totalIssues === 0 
              ? 'Nenhum problema encontrado' 
              : `${totalIssues} ${totalIssues === 1 ? 'item requer' : 'itens requerem'} atenção`
            }
          </p>
        </div>
      </div>
      <div className="space-y-3">
        {errors?.length > 0 && (
          <div className="space-y-2">
            {errors?.map((error, index) => (
              <div
                key={`error-${index}`}
                className="flex items-start gap-3 p-3 rounded-md bg-error/10 border border-error/20"
              >
                <Icon name="XCircle" size={18} className="text-error mt-0.5 flex-shrink-0" />
                <div className="flex-1 min-w-0">
                  <p className="caption font-medium text-error mb-1">
                    {error?.title}
                  </p>
                  <p className="caption text-muted-foreground">
                    {error?.message}
                  </p>
                  {error?.line && (
                    <p className="caption text-muted-foreground text-xs mt-1">
                      Linha {error?.line}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        {warnings?.length > 0 && (
          <div className="space-y-2">
            {warnings?.map((warning, index) => (
              <div
                key={`warning-${index}`}
                className="flex items-start gap-3 p-3 rounded-md bg-warning/10 border border-warning/20"
              >
                <Icon name="AlertTriangle" size={18} className="text-warning mt-0.5 flex-shrink-0" />
                <div className="flex-1 min-w-0">
                  <p className="caption font-medium text-warning mb-1">
                    {warning?.title}
                  </p>
                  <p className="caption text-muted-foreground">
                    {warning?.message}
                  </p>
                  {warning?.line && (
                    <p className="caption text-muted-foreground text-xs mt-1">
                      Linha {warning?.line}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        {info?.length > 0 && (
          <div className="space-y-2">
            {info?.map((item, index) => (
              <div
                key={`info-${index}`}
                className="flex items-start gap-3 p-3 rounded-md bg-primary/10 border border-primary/20"
              >
                <Icon name="Info" size={18} className="text-primary mt-0.5 flex-shrink-0" />
                <div className="flex-1 min-w-0">
                  <p className="caption font-medium text-primary mb-1">
                    {item?.title}
                  </p>
                  <p className="caption text-muted-foreground">
                    {item?.message}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ValidationResults;